/**
 * Tiny inline SVG sparkline. Renders a light polyline over `values`.
 * Colour thresholds depend on the unit (higher-is-better for km/L,
 * lower-is-better for L/hr) so a drifting forklift/truck stands out.
 */
export const Sparkline = ({
  values = [],
  unit = 'km/L',
  width = 80,
  height = 22,
  className = '',
  testId,
}) => {
  if (!Array.isArray(values) || values.length < 2) {
    return <span className={`text-xs text-slate-300 ${className}`} data-testid={testId}>—</span>;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const step = width / (values.length - 1);
  const points = values
    .map((v, i) => {
      const x = i * step;
      const y = height - ((v - min) / range) * (height - 4) - 2;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  // Colour rules match the KPI cards elsewhere in the app.
  const latest = values[values.length - 1];
  const isLph = unit === 'L/hr';
  const stroke = isLph
    ? (latest <= 2 ? '#059669' : latest <= 4 ? '#D97706' : '#DC2626')
    : (latest >= 10 ? '#059669' : latest >= 7 ? '#D97706' : '#DC2626');

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      role="img"
      aria-label={`${unit} trend, latest ${latest}`}
      data-testid={testId}
    >
      <polyline
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        points={points}
      />
      <circle
        cx={(values.length - 1) * step}
        cy={height - ((latest - min) / range) * (height - 4) - 2}
        r="2"
        fill={stroke}
      />
    </svg>
  );
};

export default Sparkline;
